import { FunctionComponent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { GET_PARENT } from '@/modules/API/parent/parentHandler'
import { useLazyQuery, useQuery } from '@apollo/client'
import Loading from '@/components/Loading/Loading'
import ErrorMessage from '@/components/_custom/ErrorMessage/ErrorMessage'
import ResetPasswordDialog from '../Dialog/resetPassword'
import ChangeLanguageDialog from '../Dialog/changeLanguage'
import SupportDialog from '../Dialog/supportDialog'
import Desktop from '@/modules/desktopMobile/desktop'
import ParentHomeDesktop from './parentHomeDesktop'
import ParentHomeMobile from './parentHomeMobile'
import Mobile from '@/modules/desktopMobile/mobile'
import { GET_DAYCARE_GROUP_URLS_FOR_DAYCARE } from '@/modules/API/daycareGroup/daycareGroupUrl'
import { DaycareGroupsUrl } from '@/types/DaycareGroup'

interface ParentHomeProps {
    backendVersion: string
    frontendVersion: string
}

const ParentHome: FunctionComponent<ParentHomeProps> = ({ backendVersion, frontendVersion }: ParentHomeProps) => {
    const { t } = useTranslation()

    const [email, setEmail] = useState<string>('')
    const [firstname, setFirstname] = useState<string>('')

    const [isDialogForgottenPasswordOpen, setDialogForgottenPasswordOpen] = useState<boolean>(false)
    const [isDialogChangeLanguageOpen, setDialogChangeLanguageOpen] = useState<boolean>(false)

    const [isDialogSupportOpen, setDialogSupportOpen] = useState<boolean>(false)

    const { loading: loadingParent, error: errorParent, data: dataParent } = useQuery(GET_PARENT)

    useEffect(() => {
        if (dataParent) {
            setEmail(dataParent.getParent.email)
            setFirstname(dataParent.getParent.firstname)
        }
    }, [dataParent])

    const [daycaresUrls, setDaycaresUrls] = useState<DaycareGroupsUrl[]>([])

    const [getDaycareUrls, { data: dataDaycareUrls }] = useLazyQuery(GET_DAYCARE_GROUP_URLS_FOR_DAYCARE)

    useEffect(() => {
        if (dataDaycareUrls) {
            setDaycaresUrls(dataDaycareUrls.getDaycareGroupUrlsForDaycare)
        }
    }, [dataDaycareUrls])

    useEffect(() => {
        getDaycareUrls()
    }, [email])

    return (
        <>
            {loadingParent && <Loading overall />}
            <Desktop>
                <ParentHomeDesktop
                    firstname={firstname}
                    backendVersion={backendVersion}
                    frontendVersion={frontendVersion}
                    setDialogChangeLanguageOpen={setDialogChangeLanguageOpen}
                    setDialogForgottenPasswordOpen={setDialogForgottenPasswordOpen}
                    setDialogSupportOpen={setDialogSupportOpen}
                    daycaresUrls={daycaresUrls}
                />
            </Desktop>
            <Mobile>
                <ParentHomeMobile
                    firstname={firstname}
                    backendVersion={backendVersion}
                    frontendVersion={frontendVersion}
                    setDialogChangeLanguageOpen={setDialogChangeLanguageOpen}
                    setDialogForgottenPasswordOpen={setDialogForgottenPasswordOpen}
                    setDialogSupportOpen={setDialogSupportOpen}
                    daycaresUrls={daycaresUrls}
                />
            </Mobile>
            {errorParent && <ErrorMessage error={t('generalError')} />}
            <ResetPasswordDialog
                email={email}
                open={isDialogForgottenPasswordOpen}
                parent
                handleClose={(): void => setDialogForgottenPasswordOpen(false)}
            />
            <ChangeLanguageDialog
                open={isDialogChangeLanguageOpen}
                parent
                handleClose={(): void => setDialogChangeLanguageOpen(false)}
            />
            <SupportDialog
                open={isDialogSupportOpen}
                handleClose={(): void => setDialogSupportOpen(false)}
                isParent
                email={email}
            />
        </>
    )
}

export default ParentHome
